import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../../shared/shared.module';
import { MaterialModule } from '../../../../shared/material.module';
import { OnBoardingVideoComponent } from './on-boarding-video.component';
import { PipesModule } from 'src/app/helpers/pipes/pipes.module';


@NgModule({
  declarations: [OnBoardingVideoComponent],
  exports: [
    OnBoardingVideoComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    PipesModule
  ]
})
export class OnBoardingVideoModule {
}
